package com.evoapps.evoshift.domain.repository

import com.evoapps.evoshift.domain.billing.BillingCustomer
import com.evoapps.evoshift.domain.model.Owner
import com.evoapps.evoshift.domain.model.ContractType
import kotlinx.coroutines.flow.Flow

interface OwnerRepository {
    suspend fun getOwner(uid: String): Result<Owner?>
    suspend fun createOwner(owner: Owner): Result<Unit>
    suspend fun addWorkplaceToOwner(uid: String, workplaceId: String): Result<Unit>
    suspend fun updateBusinessName(uid: String, newBusinessName: String): Result<Unit>

    /**
     * Records that the owner accepted the data processing agreement [version] now
     * (`dpaAcceptedVersion` / `dpaAcceptedAt` on owners/{uid}; GDPR Art. 28(9), SH-50).
     */
    suspend fun recordDpaAcceptance(uid: String, version: String): Result<Unit>

    /**
     * The owner's RevenueCat customer as the webhook mirrors it (`owners/{uid}/billing/revenuecat`,
     * written only by Cloud Functions): the plan bought on any platform. Empty when there is none.
     */
    fun observeBilling(uid: String): Flow<BillingCustomer>

    // Contract Type Management
    suspend fun getContractTypes(ownerId: String): Result<List<ContractType>>

    /**
     * The owner's contract types, live (the request types' settings tick them). Empty when the
     * caller may not read them (only the owner and the financial managers may).
     */
    fun observeContractTypes(ownerId: String): Flow<List<ContractType>> =
        kotlinx.coroutines.flow.flow { emit(getContractTypes(ownerId).getOrDefault(emptyList())) }
    suspend fun addContractType(ownerId: String, contractType: ContractType): Result<String> // Returns new ID
    suspend fun updateContractType(ownerId: String, contractType: ContractType): Result<Unit>
    suspend fun deleteContractType(ownerId: String, contractTypeId: String): Result<Unit>
}
